<template>
  <div class="dashboard">
    <navigation/>
    <router-view/>
  </div>
</template>

<script>
import { app } from '@/firebase'
import navigation from '@/components/navigation'

export default {
  name: 'Dashboard',
  components: {
    navigation,
  },
  mounted() {
    const currentUserID = app.auth().currentUser.uid
    // this.$store.commit('setActiveUser', currentUserID)
    // this.$store.dispatch('setActiverUserSettingsAction', currentUserID)
  }
}
</script>

<style scoped>
  .dashboard {
    margin-top: 90px;
  }
</style>